import { useEffect } from "react";
import { toast } from "sonner";
import { WELCOME_MESSAGES } from "@/i18n";

/**
 * First-contact welcome toast. Fires once per browser in the learner's
 * auto-detected language (set by `useT.js` before this mounts). The
 * `oak_welcomed` flag prevents repeats on return visits.
 */
export default function WelcomeGate() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    try {
      if (localStorage.getItem("oak_welcomed") === "1") return;
    } catch {
      return;
    }
    const lang = localStorage.getItem("oak_lang") || "en";
    const msg = WELCOME_MESSAGES[lang] || WELCOME_MESSAGES.en;
    // Tiny delay so sonner is mounted + the hero animation settles first.
    const id = setTimeout(() => {
      toast(msg, {
        duration: 4000,
        className: "oak-welcome-toast",
        style: {
          background: "linear-gradient(135deg, rgba(255,123,0,0.18) 0%, rgba(93,63,211,0.22) 50%, rgba(0,68,255,0.18) 100%)",
          border: "1px solid rgba(255,176,103,0.28)",
          color: "#fff",
          backdropFilter: "blur(24px) saturate(1.4)",
          WebkitBackdropFilter: "blur(24px) saturate(1.4)",
          boxShadow: "0 20px 60px -20px rgba(255,123,0,0.35), 0 0 0 1px rgba(255,255,255,0.04) inset",
          fontFamily: "Outfit, system-ui, sans-serif",
          fontSize: 13.5,
          letterSpacing: 0.1,
          padding: "14px 18px",
        },
      });
      try { localStorage.setItem("oak_welcomed", "1"); } catch {}
    }, 700);
    return () => clearTimeout(id);
  }, []);

  return null;
}
